import { Link } from "react-router-dom";
import type { Film } from "@/lib/film";

interface FilmCardProps {
  film: Film;
  showRank?: number;
}

export default function FilmCard({ film, showRank }: FilmCardProps) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className="group block rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors duration-300 cursor-pointer"
      title={`${film.title} - 日本一级片`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={film.cover}
          alt={`${film.title}（${film.originalTitle}）${film.year} 年日本${film.genres.join("、")}影片封面`}
          title={`${film.title} 日本${film.genres[0]}影片`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-80"></div>

        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-background-50/90 text-[11px] text-foreground-800 font-label">
          {film.quality}
        </span>

        {typeof showRank === "number" && (
          <span className="absolute top-2 right-2 w-7 h-7 rounded-md bg-primary-600 text-background-50 flex items-center justify-center font-heading text-sm">
            {showRank}
          </span>
        )}

        <div className="absolute bottom-2 left-2 right-2 flex items-center justify-between">
          <span className="flex items-center gap-1 text-background-50 text-xs font-label">
            <i className="ri-star-fill text-accent-400 text-[11px] w-3.5 h-3.5 flex items-center justify-center"></i>
            {film.rating.toFixed(1)}
          </span>
          <span className="text-background-50/85 text-[11px] font-label">{film.duration} 分钟</span>
        </div>
      </div>

      <div className="p-3 md:p-3.5">
        <h3 className="text-sm md:text-[15px] text-foreground-950 font-medium leading-snug line-clamp-1 group-hover:text-primary-700 transition-colors">
          {film.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-1 font-label">{film.originalTitle}</p>
        <div className="mt-2.5 flex items-center justify-between gap-2">
          <span className="text-xs text-foreground-600 truncate">{film.genres.slice(0, 2).join(" / ")}</span>
          <span className="text-xs text-foreground-500 shrink-0 font-label">{film.year}</span>
        </div>
      </div>
    </Link>
  );
}